/* eslint-disable no-unused-vars */
import { PencilButton } from './PencilButton'
import { RevertButton } from './RevertButton'

export function LogoEntry({...params}){

    let pageMode = params.pageMode

    return(
        <>
            <br/>
            <p>LogoEntry</p>
        </>
    )

}